import { useQuery } from '@tanstack/react-query'
import { signupValidateCheck } from 'lib/api/auth/singupValidateCheck'

const useSignupValidateCheck = ({ name, value }, options) => {
  return useQuery(createKey(name, value), signupValidateCheck, { ...options })
}

const createKey = (name, value) => ['signup-validate', name, value]

export default useSignupValidateCheck
